import styled from "@emotion/styled";
import theme from "../../styles/theme";
import { Panel } from "@xometry/xometry_loft";

export const GeoMessagePanel = styled(Panel)`
  margin-bottom: ${theme.spacing[2]};
  background-color: ${theme.colors.yellows[75]};
  text-align: center;
  font-weight: ${theme.fontWeights.semibold};

  a {
    font-weight: ${theme.fontWeights.bold};
    color: ${theme.colors.blues[100]};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
